export default __webpack_public_path__ + "static/media/mgs.db5d3574.jpeg";